import { MultiFilterSelectField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const StyledMultiFilterSelectField = styled(MultiFilterSelectField)`
  max-width: ${pxToRem(480)};

`;
